import { useEffect, useState } from "react";
import { t, locale } from "../i18n";
import { confirmDialog } from "../dialog";
import CodeInput, { CODE_LENGTH } from "./CodeInput";

const API = process.env.REACT_APP_API_URL || "";

// Les parties mises en pause (Smash or Pass, Références en détente) auxquelles
// ce joueur a participé : la reprendre rouvre un salon, ou y renvoie si un
// autre participant l'a déjà rouverte.
function PausedGames({ player, onResumeSaved }) {
  const [list, setList] = useState([]);
  const query = () => {
    let pid = "";
    try { pid = localStorage.getItem("popuquiz_playerId") || ""; } catch (_) {}
    const headers = player?.token ? { Authorization: `Bearer ${player.token}` } : {};
    return { url: `${API}/saved-games?playerId=${encodeURIComponent(pid)}`, headers, pid };
  };
  const load = () => {
    const { url, headers } = query();
    fetch(url, { headers }).then(r => (r.ok ? r.json() : [])).then(setList).catch(() => setList([]));
  };
  useEffect(load, [player?.token]); // eslint-disable-line react-hooks/exhaustive-deps

  const remove = async (g) => {
    if (!(await confirmDialog(t("home.pausedRemoveAsk")))) return;
    const { headers, pid } = query();
    await fetch(`${API}/saved-games/${g.id}?playerId=${encodeURIComponent(pid)}`, { method: "DELETE", headers }).catch(() => {});
    load();
  };

  if (!list.length) return null;
  const fmt = iso => (iso ? new Date(iso).toLocaleDateString(locale(), { day: "numeric", month: "short" }) : "");
  return (
    <div class="paused-games">
      <div class="paused-title">{t("home.pausedTitle")}</div>
      <div class="paused-list">
        {list.map(g => (
          <div key={g.id} class="paused-row">
            <div class="paused-info">
              <span class="paused-name">{t(`modes.${g.mode}`)} · {g.themes.join(", ")}</span>
              <span class="paused-meta">
                {g.progress ? t("home.pausedProgress", { found: g.progress.found, total: g.progress.total }) + " · " : ""}
                {g.participants.join(", ")} · {fmt(g.updatedAt)}
              </span>
            </div>
            <button class="btn btn-primary paused-go" onClick={() => onResumeSaved(g.id)}>
              {g.resumedCode ? t("home.pausedJoin") : t("home.pausedResume")}
            </button>
            <button class="btn paused-remove" onClick={() => remove(g)} title={t("home.pausedRemove")} aria-label={t("home.pausedRemove")}>×</button>
          </div>
        ))}
      </div>
    </div>
  );
}

// Home screen for an identified player: create a game, join one by code, or
// return to the one they never left (going back from /partie/:code).
// Les icônes s'arrêtent à cet écran : créer, rejoindre, admin. Ailleurs, le
// texte suffit.
function Lobby({ player, ongoingGameId, inGame, isHost, onResume, onCreate, onJoin, onCloseLobby, onLeave, onResumeSaved }) {
  const [join, setJoin] = useState(false)
  const [gameId, setGameId] = useState("")

  const submit = () => { if (gameId.length === CODE_LENGTH) onJoin(gameId); };

  return (
    <div class="Lobby">
      <div class="main-content">
        {!join ? (
          <div class="centered-content">
            {/* Une partie est en cours : ni accueil ni invitation à en créer
                une autre — on propose d'y retourner ou d'en sortir, point. */}
            {!ongoingGameId && (
              <>
                <div class="main-title">{t("home.welcome", { name: player.pseudo })}</div>
                <div class="main-subtitle">{t("home.subtitle")}</div>
              </>
            )}
            {ongoingGameId ? (
              <div class="btn-group vertical">
                <button class="btn btn-primary" onClick={onResume}>
                  {t("home.resume", { code: ongoingGameId })}
                </button>
                {isHost && (
                  <button class="btn btn-danger" onClick={onCloseLobby}>{t("home.closeLobby")}</button>
                )}
                <button class="btn btn-danger-soft" onClick={onLeave}>
                  {t(inGame ? "home.leaveGame" : "home.leaveLobby")}
                </button>
              </div>
            ) : (
              <div class="btn-group vertical">
                <button class="btn btn-primary" onClick={onCreate}><i class="bi bi-stars"></i> {t("home.create")}</button>
                <button class="btn" onClick={() => setJoin(true)}><i class="bi bi-play-fill"></i> {t("home.join")}</button>
              </div>
            )}
            {!ongoingGameId && <PausedGames player={player} onResumeSaved={onResumeSaved} />}
          </div>
          ) : (
            <div class="centered-content join-screen">
              <div class="join-card">
                <div class="main-title">{t("home.joinTitle")}</div>
                <label class="field-label" for="partyCode">{t("home.codeLabel")}</label>
                <CodeInput value={gameId} onChange={setGameId} onSubmit={submit} autoFocus />
              </div>
              <div class="btn-group vertical join-actions">
                <button class="btn btn-primary" disabled={gameId.length < CODE_LENGTH} onClick={submit}>
                  {t("home.joinSubmit")}
                </button>
                <button class="btn" onClick={() => setJoin(false)}>{t("common.back")}</button>
              </div>
            </div>
          )}
        </div>
    </div>
  );
}

export default Lobby;
